import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "./AboutRoute.css";
import InfoIcon from "@material-ui/icons/Info";
import DeveloperModeIcon from "@material-ui/icons/DeveloperMode";
import Aos from "aos";
import "aos/dist/aos.css";
import DevicesIcon from "@material-ui/icons/Devices";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ykabout from "./images/ykabout.jpg";

function AboutRoute() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [messageError, setMessageError] = useState("");

  const handleSubmit = (e) => {
    if (!name) {
      setNameError("Name should not be empty");
      return false;
    } else if (!email) {
      setEmailError("Email is mandatory");
      return false;
    } else if (message.length < 10) {
      setMessageError("Message should be atleast of 10 charaters");
      return false;
    } else {
      console.log("submitted");
    }
  };

  const sendEmail = (event) => {
    event.preventDefault();
    emailjs
      .sendForm(
        "gmail",
        "template_z4q06bj",
        event.target,
        "user_92hOlf2bG2z6K13HEq4fT"
      )
      .then(
        (result) => {
          if (name !== "" && email !== "" && message !== "") {
            alert("SUCCESSFULLY SUBMITTED", result.status, result.text);
            setName("");
            setEmail("");
            setMessage("");
            setPhone("");
          } else {
            console.log("all fields mandatory");
          }
        },
        (error) => {
          alert(error.text);
        }
      );
    event.target.reset();
  };

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  return (
    <div className="aboutRoute">
      <div className="container">
        <div className="aboutRoute__header">
          <InfoIcon className="aboutRoute__icons" />
          <h1>ABOUT</h1>
        </div>
        <div className="aboutRoute__info">
          <div data-aos="fade-left">
            <img src={ykabout} alt="yk" />
          </div>
          <div data-aos="fade-right" className="who__hire">
            <h2>Who Am I</h2>
            <p>
              Hey guys <br /> My name is <span>Yahiya Khan</span>. I'm a Web
              Developer based in Banglore. Passionate about what I do. Always
              interested in how the sites were made. Now i have acquired the
              skills neccessary to built great and premium websites.
            </p>
            <div className="aboutRoute__hire">
              <DeveloperModeIcon className="hireIcon" />
              <h2>Hire me</h2>
            </div>
            <p>
              Im open for collaborations. I can make for you great web designs,
              portfolios, landing pages and much others at good price.
            </p>
          </div>
        </div>
        <div className="container__creation">
          <DevicesIcon className="container__creationIcon" />
          <h2>YK Creations</h2>
        </div>
        <h3 className="container__red" data-aos="fade-right">
          " This Portfolio doesn't perform any user-interaction. "
        </h3>
        <h3 className="container__yellow" data-aos="fade-left">
          " This Portfolio give you all informations about me and the projects
          that i have done so far. "
        </h3>
        <h3 className="container__green" data-aos="fade-right">
          " Portfolio is Developed and Maintained by Myself. "
        </h3>
        <div className="container__contact">
          <h1>GET IN TOUCH</h1>
          <p>
            Say Hi! or contact me on social media. Iam open for collabration
          </p>

          <div className="contactForm">
            <form onSubmit={sendEmail}>
              <div className="formCommon">
                <label htmlFor="">
                  Name <span>*</span>
                </label>
                <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameError("");
                  }}
                />
              </div>
              <p style={{ color: "red" }}>{nameError}</p>
              <div className="formCommon">
                <label htmlFor="">
                  Email <span>*</span>
                </label>
                <input
                  type="Email"
                  placeholder="Your Email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError("");
                  }}
                />
              </div>
              <p style={{ color: "red" }}>{emailError}</p>

              <div className="formCommon">
                <label htmlFor="">
                  Phone <span></span>
                </label>
                <input
                  placeholder="Your Phone Number"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="formCommon">
                <label htmlFor="">
                  Message <span>*</span>
                </label>
                <textarea
                  placeholder="Hii! Drop your message here."
                  name="message"
                  id=""
                  cols="30"
                  rows="10"
                  className="message"
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setMessageError("");
                  }}
                ></textarea>
              </div>
              <p style={{ color: "red" }}>{messageError}</p>

              <button type="submit" onClick={handleSubmit}>
                SUBMIT
              </button>
            </form>
          </div>

          <div className="findMe">
            <h2>Find me on</h2>
            <div className="findMe__icons">
              <a
                href="https://www.facebook.com/yahiya.khan.100046"
                style={{ color: "white" }}
              >
                <FacebookIcon
                  style={{ width: "40px", height: "40px", cursor: "pointer",  }}
                />
              </a>
              <a
                href="https://www.instagram.com/its_a_y.a.khan/"
                style={{ color: "white" }}
              >
                <InstagramIcon
                  style={{ width: "40px", height: "40px", cursor: "pointer" }}
                />
              </a>
              <a
                href="https://www.linkedin.com/in/yahiya-khan-153a81184"
                style={{ color: "white" }}
              >
                <LinkedInIcon
                  style={{ width: "40px", height: "40px", cursor: "pointer" }}
                />
              </a>
              <a
                href="https://twitter.com/YahiyaK79590805"
                style={{ color: "white" }}
              >
                <TwitterIcon
                  style={{ width: "40px", height: "40px", cursor: "pointer", }}
                />
              </a>
            </div>
            <div className="location">
              <LocationOnIcon />
              <p>Humnabad 585330, Karnataka, INDIA</p>
            </div>
            <p>
              MADE WITH
              <span role="img" aria-labelledby="heart">
                💖
              </span>
              BY YAHIYA KHAN
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutRoute;
